import { CALL_API } from '../middleware/ApiMiddleware';

export const FINE_CREATE_REQUEST = 'FINE_CREATE_REQUEST';
export const FINE_CREATE_FAILURE = 'FINE_CREATE_FAILURE';
export const FINE_CREATE_SUCCESS = 'FINE_CREATE_SUCCESS';

export const GET_FINE_LIST_REQUEST = 'GET_FINE_LIST_REQUEST';
export const GET_FINE_LIST_FAILURE = 'GET_FINE_LIST_FAILURE';
export const GET_FINE_LIST_SUCCESS = 'GET_FINE_LIST_SUCCESS';

export const GET_FINE_REQUEST = 'GET_FINE_REQUEST';
export const GET_FINE_FAILURE = 'GET_FINE_FAILURE';
export const GET_FINE_SUCCESS = 'GET_FINE_SUCCESS';

export const EDIT_FINE_REQUEST = 'EDIT_FINE_REQUEST';
export const EDIT_FINE_FAILURE = 'EDIT_FINE_FAILURE';
export const EDIT_FINE_SUCCESS = 'EDIT_FINE_SUCCESS';

export const EDIT_FINE_SEQUENCE_REQUEST = 'EDIT_FINE_SEQUENCE_REQUEST';
export const EDIT_FINE_SEQUENCE_FAILURE = 'EDIT_FINE_SEQUENCE_FAILURE';
export const EDIT_FINE_SEQUENCE_SUCCESS = 'EDIT_FINE_SEQUENCE_SUCCESS';

export const GET_LATE_FEES_LIST_REQUEST = 'GET_LATE_FEES_LIST_REQUEST';
export const GET_LATE_FEES_LIST_SUCCESS = 'GET_LATE_FEES_LIST_SUCCESS';
export const GET_LATE_FEES_LIST_FAILURE = 'GET_LATE_FEES_LIST_FAILURE';

export const GET_LATE_FEE_REQUEST = 'GET_LATE_FEE_REQUEST';
export const GET_LATE_FEE_SUCCESS = 'GET_LATE_FEE_SUCCESS';
export const GET_LATE_FEE_FAILURE = 'GET_LATE_FEE_FAILURE';

export const CREATE_LATE_FEE_REQUEST = 'CREATE_LATE_FEE_REQUEST';
export const CREATE_LATE_FEE_SUCCESS = 'CREATE_LATE_FEE_SUCCESS';
export const CREATE_LATE_FEE_FAILURE = 'CREATE_LATE_FEE_FAILURE';

export const EDIT_LATE_FEE_REQUEST = 'EDIT_LATE_FEE_REQUEST';
export const EDIT_LATE_FEE_SUCCESS = 'EDIT_LATE_FEE_SUCCESS';
export const EDIT_LATE_FEE_FAILURE = 'EDIT_LATE_FEE_FAILURE';

const baseURL = 'xerce/config/fines';
const lateFeesBaseURL = 'xerce/config/late-fee';

export const createFine = (createFineRequest: IConfigFineRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}`,
    method: 'post',
    body: createFineRequest,
    authenticated: true,
    types: [FINE_CREATE_REQUEST, FINE_CREATE_SUCCESS, FINE_CREATE_FAILURE],
  },
});

export const fetchFineList = () => ({
  [CALL_API]: {
    endpoint: `${baseURL}`,
    method: 'get',
    authenticated: true,
    types: [GET_FINE_LIST_REQUEST, GET_FINE_LIST_SUCCESS, GET_FINE_LIST_FAILURE],
  },
});

export const fetchFine = (fineId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${fineId}`,
    method: 'get',
    authenticated: true,
    types: [GET_FINE_REQUEST, GET_FINE_SUCCESS, GET_FINE_FAILURE],
  },
});

export const updateFine = (fineId: number, createFineRequest: IConfigFineRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${fineId}`,
    method: 'put',
    body: createFineRequest,
    authenticated: true,
    types: [EDIT_FINE_REQUEST, EDIT_FINE_SUCCESS, EDIT_FINE_FAILURE],
  },
});

export const editFineSequence = (sequence: number[]) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/sequence`,
    method: 'put',
    body: { sequence },
    authenticated: true,
    types: [EDIT_FINE_SEQUENCE_REQUEST, EDIT_FINE_SEQUENCE_SUCCESS, EDIT_FINE_SEQUENCE_FAILURE],
  },
});

export const fetchLateFeesList = (reqParams: ILateFeeRequest = {}) => {
  const params = { ...reqParams };

  if (params && params.associatedViolationIds) {
    // tslint:disable-next-line: max-line-length
    params.associatedViolationIds = params.associatedViolationIds;
  }

  return {
    [CALL_API]: {
      endpoint: `${lateFeesBaseURL}`,
      method: 'get',
      params,
      authenticated: true,
      types: [GET_LATE_FEES_LIST_REQUEST, GET_LATE_FEES_LIST_SUCCESS, GET_LATE_FEES_LIST_FAILURE],
    },
  };
};

export const fetchLateFee = (lateFeeId: number) => ({
  [CALL_API]: {
    endpoint: `${lateFeesBaseURL}/${lateFeeId}`,
    method: 'get',
    authenticated: true,
    types: [GET_LATE_FEE_REQUEST, GET_LATE_FEE_SUCCESS, GET_LATE_FEE_FAILURE],
  },
});

export const createLateFee = (createLateFeeRequest: IConfigLateFeeRequest) => ({
  [CALL_API]: {
    endpoint: `${lateFeesBaseURL}`,
    method: 'post',
    body: createLateFeeRequest,
    authenticated: true,
    types: [CREATE_LATE_FEE_REQUEST, CREATE_LATE_FEE_SUCCESS, CREATE_LATE_FEE_FAILURE],
  },
});

export const updateLateFee = (lateFeeId: number, updateLateFeeRequest: IConfigLateFeeRequest) => ({
  [CALL_API]: {
    endpoint: `${lateFeesBaseURL}/${lateFeeId}`,
    method: 'put',
    body: updateLateFeeRequest,
    authenticated: true,
    types: [EDIT_LATE_FEE_REQUEST, EDIT_LATE_FEE_SUCCESS, EDIT_LATE_FEE_FAILURE],
  },
});
